module.exports = __webpack_public_path__ + "static/img/主图2-4.7b26c6aa.png";